import { render, staticRenderFns } from "./driver-feedback.vue?vue&type=template&id=0e3b82e2&scoped=true"
import script from "./driver-feedback.vue?vue&type=script&lang=js"
export * from "./driver-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b82e2",
  null
  
)

export default component.exports